
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import simplify from "@turf/simplify";

const DrawLineString = MapboxDraw.modes.draw_line_string;
const geojsonTypes = MapboxDraw.constants.geojsonTypes;
const cursors = MapboxDraw.constants.cursors;
const types = MapboxDraw.constants.types;
const updateActions = MapboxDraw.constants.updateActions;
const modes = MapboxDraw.constants.modes;
const events = MapboxDraw.constants.events;


const measureMode = Object.assign({}, DrawLineString)

measureMode.user_color = "#5078FF";
measureMode.user_thinkness = 3;

measureMode.onSetup = function(opts) {
	opts = opts || {};
	var direction = 'forward';
	var currentVertexPosition = (opts.startCoordinate ? 1 : 0);
	
	const existintingFeature = opts.feature;
	
	const line = this.newFeature(existintingFeature ? existintingFeature : {
		type: geojsonTypes.FEATURE,
		properties: {
			type:'measure',
			color:measureMode.user_color,
			thickness: measureMode.user_thinkness
		},
		geometry: {
			type: geojsonTypes.LINE_STRING,
			coordinates: opts.startCoordinate && opts.startCoordinate.length ? [opts.startCoordinate] : []
		},
		id:'added_measure'
	});
	if(existintingFeature){

		var lastCoord = line.coordinates.length-1;
		currentVertexPosition = lastCoord +1;
		line.addCoordinate(currentVertexPosition, ...line.coordinates[lastCoord]);

	}
	this.clearSelectedFeatures();

	this.addFeature(line);
	

	this.updateUIClasses({ mouse: cursors.ADD });
	this.setActionableState({
		trash: true
	});

	var state = {
		line,
		currentVertexPosition: currentVertexPosition,
		dragMoving: false,
		direction: direction
	}
	
	return state;
};
measureMode.atFirstCoord = function (e){
	return (
		e &&
		e.featureTarget && 
		e.featureTarget.properties && 
		e.featureTarget.properties.meta == 'vertex' && 
		e.featureTarget.properties.coord_path == 0
	);
}
measureMode.clickOnVertex = function(state, e) {
	if (state.currentVertexPosition > 1 && this.atFirstCoord(e)) {
		state.line.updateCoordinate(state.currentVertexPosition, state.line.coordinates[0][0],state.line.coordinates[0][1]);

		state.currentVertexPosition++;
		state.line.updateCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);
	
		return this.changeMode(modes.SIMPLE_SELECT);
	}
	return this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
};
measureMode.clickAnywhere = function(state, e) {
	if (state.currentVertexPosition > 0 && MapboxDraw.lib.isEventAtCoordinates(e, state.line.coordinates[state.currentVertexPosition - 1])) {
		return this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
	}
	if (state.currentVertexPosition > 1 && MapboxDraw.lib.isEventAtCoordinates(e, state.line.coordinates[0])) {
		state.line.updateCoordinate(state.currentVertexPosition, state.line.coordinates[0][0],state.line.coordinates[0][1]);
		
		return this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
	}
	this.updateUIClasses({ mouse: cursors.ADD });
	
	state.line.updateCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);

	state.currentVertexPosition++;
	state.line.updateCoordinate(state.currentVertexPosition, e.lngLat.lng, e.lngLat.lat);

};
measureMode.toDisplayFeatures = function(state, geojson, display) {
	var isActiveLine = geojson.properties.id === state.line.id;
	geojson.properties.active = (isActiveLine) ? MapboxDraw.constants.activeStates.ACTIVE : MapboxDraw.constants.activeStates.INACTIVE;
	if (!isActiveLine) { return display(geojson); }
	// Only render the line if it has at least one real coordinate
	if (geojson.geometry.coordinates.length < 2) { return; }
	geojson.properties.meta = MapboxDraw.constants.FEATURE;

	for(var i = 0; i < geojson.geometry.coordinates.length-1; i++){

		display(MapboxDraw.lib.createVertex(
			state.line.id,
			geojson.geometry.coordinates[i],
			i,
			false
		));
	}

	display(geojson);
};

export default measureMode